'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _BondDemoRedirect = require('./BondDemoRedirect.css');

var _BondDemoRedirect2 = _interopRequireDefault(_BondDemoRedirect);

var _container = require('../../helpers/container');

var _container2 = _interopRequireDefault(_container);

var _fossilFuelBondsSocialShare = require('../../../static/images/fossil-fuel-bonds-social-share.png');

var _fossilFuelBondsSocialShare2 = _interopRequireDefault(_fossilFuelBondsSocialShare);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BondRedirect = (_dec = (0, _reactCssModules2.default)(_BondDemoRedirect2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(BondRedirect, _Component);

  function BondRedirect(props) {
    (0, _classCallCheck3.default)(this, BondRedirect);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BondRedirect.__proto__ || (0, _getPrototypeOf2.default)(BondRedirect)).call(this, props));

    _this.state = {
      title: 'Fossil Fuel Bonds in 401(k)s',
      description: 'If there are fossil fuel bonds in your 401(k), ' + 'you\'re effectively lending your retirement savings ' + 'to companies so they can mine for coal and drill ' + 'for oil.',
      url: _config2.default.domain + _config2.default.routes.fossilFuelBondsIn401ks
    };
    return _this;
  }
  //


  (0, _createClass3.default)(BondRedirect, [{
    key: 'render',
    value: function render() {
      this.context.router.push(_config2.default.routes.fossilFuelBondsIn401ks);
      var socialShareUrl = _config2.default.domain + _fossilFuelBondsSocialShare2.default.replace(/.*dist/, '/dist');
      return _react2.default.createElement(
        'div',
        { styleName: 'main' },
        _container2.default.helmet(this.state.title, this.state.description, this.state.url),
        _react2.default.createElement(_reactHelmet2.default, { meta: [{ property: 'og:image', content: socialShareUrl }, { property: 'twitter:image', content: socialShareUrl }] }),
        _react2.default.createElement(_reactLoader2.default, { options: { scale: 0.70, top: '2.0rem' }, loaded: false })
      );
    }
  }]);
  return BondRedirect;
}(_react.Component), _class2.contextTypes = {
  router: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = BondRedirect;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/BondDemoRedirect/BondRedirect.js
// module id = 1464
// module chunks = 0